import { __exports as models } from '../../../../_virtual/models.js';

(function (exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	(function (LogLevel) {
	    LogLevel[LogLevel["NOTSET"] = 0] = "NOTSET";
	    LogLevel[LogLevel["DEBUG"] = 1] = "DEBUG";
	    LogLevel[LogLevel["INFO"] = 2] = "INFO";
	    LogLevel[LogLevel["WARNING"] = 3] = "WARNING";
	    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
	})(exports.LogLevel || (exports.LogLevel = {})); 
} (models));
//# sourceMappingURL=models.js.map
